import React from "react";
import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";
import { usePageTitle } from "../utils/brandUtils";

const HeaderWrapper = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    marginBottom: theme.spacing(3),
}));

const TitleRow = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        alignItems: "stretch",
    },
}));

const TitleCluster = styled(Box)(({ theme }) => ({
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "flex-start",
    gap: theme.spacing(1),
    flex: "1 1 auto",
    minWidth: 0,
}));

const TitleBlock = styled(Box)({
    display: "flex",
    flexDirection: "column",
    flex: "1 1 auto",
    minWidth: 0,
    overflowWrap: "anywhere",
});

const Title = styled(Typography)(({ theme }) => ({
    [theme.breakpoints.down("sm")]: {
        fontSize: theme.typography.size.xlm,
    },
}));

const TitleActions = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing(0.5),
    flexShrink: 0,
    [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
    },
}));

const ActionsBlock = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: theme.spacing(1),
    flexWrap: "wrap",
    flexShrink: 0,
}));

const FiltersRow = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(2),
    width: "100%",
}));

const PageHeader = ({ title, subtitle, titleActions, actions, filters, documentTitle }) => {
    usePageTitle(documentTitle ?? title);

    return (
        <HeaderWrapper>
            <TitleRow>
                <TitleCluster>
                    <TitleBlock>
                        <Title variant="h4" component="h1">
                            {title}
                        </Title>
                        {subtitle && (
                            <Typography variant="body2" color="text.secondary">
                                {subtitle}
                            </Typography>
                        )}
                    </TitleBlock>
                    {titleActions && <TitleActions>{titleActions}</TitleActions>}
                </TitleCluster>
                {actions && <ActionsBlock>{actions}</ActionsBlock>}
            </TitleRow>
            {filters && <FiltersRow>{filters}</FiltersRow>}
        </HeaderWrapper>
    );
};

export default PageHeader;
